<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <sui-panel :title="$t('MSG_TIT_COMP_BSIC_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GEHS_COMP_ID')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyId }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_NAT')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.nationName }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CONN_COMP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <bqms-vendor-select
                ref="selectBqmsVendor"
                :selected="bqmsCompany"
                :readonly="true"
                :buttonDisable="true"
                @selected="onBqmsVendorSelectClick"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CORP_DSTG_NO')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="corpRegNumber"
                v-model.trim="companyData.corpRegNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
              />
              <div class="comp_spacing" />
              <sui-button
                v-if="!connectionCompanyFlag"
                v-permission:read="this.$options.name"
                type="button"
                class="comm_btn_duplicate"
                @click="onDuplicateCheckClick"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ERP_COMP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="companyData.gerpCompanyNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="15"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_REG_STATUS')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyRegistrationStateName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ACC_GRP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="companyData.companyAccountGroupCode"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="20"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ACC_GRP')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="companyData.companyAccountGroupName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="200"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TRD_PSBL_YN')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-yn-select
                ref="selectTradePossibility"
                :selected="companyData.selectedCodeValue.companyTradePossibilityYn"
                :defaultOption="'select'"
                :disabled="connectionCompanyFlag"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <sui-panel :title="$t('MSG_TIT_BIZ_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_LCL_NM')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                ref="companyName"
                v-model.trim="companyData.companyName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="500"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_BIZ_DIV')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectBizDivision"
                :selected="companyData.selectedCodeValue.bizDivisionCode"
                :pageId="this.$options.name"
                :defaultOption="'select'"
                codeId="COD_BIZ_DIV"
                :disabled="connectionCompanyFlag"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_GLBL_NM')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                ref="companyGlobalName"
                v-model.trim="companyData.companyGlobalName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="300"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_NM')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="companyRepresentativeName"
                v-model.trim="companyData.companyRepresentativeName"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="200"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ESTB_DT')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-date-picker
                ref="dp"
                v-model="companyData.companyEstablishDTM"
                :disabled="connectionCompanyFlag"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_SCALE')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectScale"
                :selected="companyData.selectedCodeValue.companyScaleCode"
                :pageId="this.$options.name"
                :defaultOption="'select'"
                codeId="COD_COMP_SCALE"
                :disabled="connectionCompanyFlag"
                @list-clicked="onScaleSelect"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_AFCP_YN')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-yn-select
                ref="selectAffiliatedDivision"
                :selected="companyData.selectedCodeValue.affiliatedCompanyDivisionCode"
                :defaultOption="'select'"
                :disabled="connectionCompanyFlag"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TCNT_EMPO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="companyData.companyEmpValue"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="10"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CBNO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="companyData.corpBizNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="60"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
        </div>
      </sui-panel>
      <sui-panel :title="$t('MSG_TIT_ADDR_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_EMAIL')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                ref="companyRepresentativeEmail"
                v-model.trim="companyData.companyRepresentativeEmail"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="100"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_TEL')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="companyRepresentativeTelNumber"
                v-model.trim="companyData.companyRepresentativeTelNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="40"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_HMPG')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                v-model.trim="companyData.companyHomepageUrl"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="1000"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_FAX_NO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="companyData.companyFaxNumber"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="40"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ADDR')"
                :vertical="false"
                required
              />
            </div>
            <div class="col-xs-7">
              <sui-text-field
                ref="companyAddress"
                v-model.trim="companyData.companyAddress"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="400"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ZIP')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="companyData.companyZipCode"
                :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
                :readonly="connectionCompanyFlag"
                maxlength="6"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <sui-panel
        :title="$t('MSG_TIT_RLTD_TASK_SITE')"
      >
        <div class="mrB20" />
        <sui-grid
          ref="taskSiteGrid"
          :columns="gridColumns0"
          :dataset="'ds13'"
          :showCountControl="false"
          :showDisplayCountControl="false"
          :initial-pagesize="3"
          :pagesizeoptions="[3]"
          :multiselect="true"
          :sortable="false"
          :filterable="false"
        >
          <div class="btn_wrapL">
            <sui-button
              v-permission:update="this.$options.name"
              type="button"
              class="comm_btn_gridTop"
              @click="addRows"
            >
              {{ $t('MSG_BTN_ROW_ADD') }}
            </sui-button>
            <sui-button
              v-permission:update="this.$options.name"
              type="button"
              class="comm_btn_gridTop"
              @click="deleteRows"
            >
              {{ $t('MSG_BTN_ROW_DEL') }}
            </sui-button>
            <sui-button
              v-permission:update="this.$options.name"
              type="button"
              class="comm_btn_gridTop"
              @click="resetRows"
            >
              {{ $t('MSG_BTN_RESET') }}
            </sui-button>
          </div>
        </sui-grid>
      </sui-panel>
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_border"
            @click="onListClick"
          >
            {{ $t('MSG_BTN_LIST') }}
          </sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button
            v-permission:update="this.$options.name"
            type="button"
            class="comm_btn_solid"
            @click="onModClick"
          >
            {{ $t('MSG_BTN_SAVE') }}
          </sui-button>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00013', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    companyId: {
      type: String,
      default: '',
    },
    targetPageId: {
      type: String,
      default: '',
    },
    siteList: {
      type: Array,
      default() {
        return [];
      },
    },
    taskList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      companyData: {
        selectedCodeValue: {
          companyTradePossibilityYn: {
            key: '',
            label: '',
          },
          bizDivisionCode: {
            key: '',
            label: '',
          },
          companyScaleCode: {
            key: '',
            label: '',
          },
          affiliatedCompanyDivisionCode: {
            key: '',
            label: '',
          },
        },
        companyId: '',
        companyName: '',
        companyGlobalName: '',
        corpRegNumber: '',
        corpBizNumber: '',
        companyRepresentativeName: '',
        companyRepresentativeTelNumber: '',
        companyEstablishDTM: '',
        companyFaxNumber: '',
        companyZipCode: '',
        companyAddress: '',
        companyRepresentativeEmail: '',
        bizTypeName: '',
        bizConditionsName: '',
        nationCode: '',
        nationName: '',
        companyHomepageYn: '',
        companyHomepageUrl: '',
        companyEmpValue: '',
        companyScaleValue: '',
        gerpCompanyNumber: '',
        connectionCompanyNumber: '',
        companyAccountGroupCode: '',
        companyAccountGroupName: '',
        companyCloseAccountsDTM: '',
        companyCapitalAmount: '',
        companyCapitalSumAmount: '',
        companyDebtSumAmount: '',
        companyDebtRatioValue: '',
        companyCapitalSurplusAmount: '',
        companyRegistrationStateCode: '',
        companyRegistrationStateName: '',
        companyUseYn: '',
      },
      vendorCreditEvaluationList: [],
      vendorCategoryList: [],
      deleteList: [],
      validFields: [
        'companyName', 'corpRegNumber', 'companyGlobalName',
        'bizDivisionCode', 'companyRepresentativeName', 'companyEstablishDTM',
        'companyScaleCode', 'affiliatedCompanyDivisionCode', 'companyRepresentativeEmail',
        'companyAddress', 'companyRepresentativeTelNumber',
      ],
      bqmsCompany: {
        connectionCompanyNumber: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_RLTD_TASK'),
        datafield: 'companyRelatedTaskDivCode',
        createwidget: (row, column, value, htmlElement) => {
          this.$nextTick(() => {
            const instance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.taskList,
              checkEditableFunction: this.selectBoxCheckEditableState,
            }, this.ds13, this.$refs.taskSiteGrid);
            instance.getComponentInstance().$on('select', () => {
              const rowindex = instance.getDatasetIndex();
              this.taskSiteDuplicateCheck(rowindex, column);
            });
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_SITE'),
        datafield: 'siteId',
        createwidget: (row, column, value, htmlElement) => {
          this.$nextTick(() => {
            const instance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.siteList,
              checkEditableFunction: this.selectBoxCheckEditableState,
              checkDisabledFunction: this.selectBoxCheckDisabledState,
            }, this.ds13, this.$refs.taskSiteGrid);
            instance.getComponentInstance().$on('select', () => {
              const rowindex = instance.getDatasetIndex();
              this.taskSiteDuplicateCheck(rowindex, column);
            });
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'companyTaskSiteUseYn',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
            checkEditableFunction: this.useYnCheckEditableState,
          }, this.ds13, this.$refs.taskSiteGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'firstRegistrationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'dsplLngId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.ds13, this.$refs.taskSiteGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_RGST_DT'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.ds13, this.$refs.taskSiteGrid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: '150px',
      }],
      originalCorpRegNumber: '',
      originalGerpCompanyNumber: '',
      duplicateFlag: false,
    };
  },
  computed: {
    // 상생업체 정보 선택 여부 -- 선택 시 true
    connectionCompanyFlag() {
      return !utils.isEmpty(this.companyData.connectionCompanyNumber);
    },
    // 사업자 식별번호 & ERP업체코드 & 국가코드 변경 여부 -- 초기값에서 변경 없을 시 true
    unchanged() {
      return utils.isEqual(this.originalCorpRegNumber, this.companyData.corpRegNumber)
              && utils.isEqual(this.originalGerpCompanyNumber, this.companyData.gerpCompanyNumber);
    },
    session() {
      return this.$store.getters.userInfo;
    },
  },
  watch: {
    companyId() {
      if (!utils.isEmpty(this.companyId) && utils.isEqual(this.$options.name, this.targetPageId)) {
        // this.reset();
        // this.$children[0].$children[1].$children[1].reveal();
        this.$children[0].$children[1].$children[1].$el.parentElement.parentElement.scrollTop = 0;
        this.companyDataLoad(this.companyId);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.companyId) && utils.isEqual(this.$options.name, this.targetPageId)) {
        this.companyDataLoad(this.companyId);
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
  },
  destroyed() {},
  datasets: [{
    id: 'ds13',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'dataset-row-id', map: 'dataset-row-id' },
      { type: 'string', name: 'companyId', map: 'companyId' },
      { type: 'string', name: 'companyRelatedTaskDivCode', map: 'companyRelatedTaskDivCode' },
      { type: 'string', name: 'siteId', map: 'siteId' },
      { type: 'string', name: 'companyTaskSiteUseYn', map: 'companyTaskSiteUseYn' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'deleteFlag', map: 'deleteFlag' },
      { type: 'string', name: 'dsplLngId', map: 'dsplLngId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
    ],
  }],
  methods: {
    makeSnapshot() {
      const data = {};
      utils.forEach(this.companyData, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        } else {
          data[key] = utils.trim(value);
        }
      });
      return data;
    },
    reset() {
      // this.$refs.selectBqmsVendor.reset();
      utils.forEach(this.$refs, (ref, key) => {
        if (utils.startsWith(key, 'select')) {
          ref.reset();
        }
      });
      utils.forEach(this.companyData, (value, key) => {
        if (!utils.isEqual(key, 'selectedCodeValue')) {
          this.companyData[key] = '';
        }
      });
      this.vendorCreditEvaluationList = [];
      this.vendorCategoryList = [];
      this.deleteList = [];
      this.ds13.setRawData([]);
      this.ds13.submit();
      this.clearSnapshot();
    },
    onListClick() {
      if (this.isDataChanged()) {
        utils.messageBox('confirm', this.$t('MSG_ALT_NOT_SAVE_DATA'), null, () => {
          this.reset();
          this.$emit('mainViewLoad');
        });
      } else {
        this.reset();
        this.$emit('mainViewLoad');
      }
    },
    companyDataLoad(companyId) {
      http.request(this.$options.name, 'DTS_CMY_00048', {
        path: {
          'company-id': companyId,
        },
      }).then(res => {
        this.setCompanyDataByCompanyData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    setCompanyDataByCompanyData(data) {
      utils.forEach(this.companyData, (value, key) => {
        if (utils.has(data, key)) {
          this.companyData[key] = data[key] || '';
        }
      });
      this.companyData.companyEstablishDTM = utils.toStringByFormat(data.companyEstablishDTM, 'YYYY-MM-DD');
      // 선택
      this.companyData.selectedCodeValue.companyTradePossibilityYn.key = data.companyTradePossibilityYn || '';
      this.companyData.selectedCodeValue.bizDivisionCode.key = data.bizDivisionCode || '';
      this.companyData.selectedCodeValue.companyScaleCode.key = data.companyScaleCode || '';
      this.companyData.selectedCodeValue.affiliatedCompanyDivisionCode.key = data.affiliatedCompanyDivisionCode || '';
      // this.$refs.selectTradePossibility.select(data.companyTradePossibilityYn);
      // this.$refs.selectBizDivision.select(data.bizDivisionCode);
      // this.$refs.selectScale.select(data.companyScaleCode);
      // this.$refs.selectAffiliatedDivision.select(data.affiliatedCompanyDivisionCode);
      utils.forEach(data.vendorTaskSiteList, row => {
        utils.assign(row, row.firstRegistrationUserInfo);
      });
      this.ds13.setRawData(data.vendorTaskSiteList);
      // 사업자 식별번호 & ERP업체 코드 변경 여부 확인 용 저장
      this.originalCorpRegNumber = data.corpRegNumber || '';
      this.originalGerpCompanyNumber = data.gerpCompanyNumber || '';
      this.saveSnapshot(this.makeSnapshot());
    },
    onBqmsVendorSelectClick(selected) {
      if (!utils.isEmpty(selected.connectionCompanyNumber)) {
        this.connectionCompanyDataLoad(selected.connectionCompanyNumber);
      }
    },
    connectionCompanyDataLoad(eprCode) {
      http.request(this.$options.name, 'DTS_CMY_00045', {
        path: {
          'epr-code': eprCode,
        },
      }).then(res => {
        // 업체 등록여부 체크
        this.duplicateCheckAction(this.getCheckData(res.data.taxNo2, res.data.erpeprCode), res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    setCompanyDataByConnectionCompanyData(data) {
      // 기본정보 업데이트
      const city = utils.isEmpty(data.localeCityName) ? '' : data.localeCityName;
      const country = utils.isEmpty(data.localeCountryName) ? '' : data.localeCountryName;
      const bunjiNo = utils.isEmpty(data.localeBunjiNo) ? '' : data.localeBunjiNo;
      const addInfo = utils.isEmpty(data.localeAddInfo) ? '' : data.localeAddInfo;
      const address = `${city} ${country} ${bunjiNo} ${addInfo}`;
      this.vendorCreditEvaluationList = data.vendorCreditEvaluationList;
      this.vendorCategoryList = data.vendorCategoryList;
      this.companyData.connectionCompanyNumber = data.eprCode;
      this.companyData.corpRegNumber = data.taxNo2;
      this.companyData.gerpCompanyNumber = data.erpeprCode;
      this.companyData.companyAccountGroupCode = data.accountGroupCode;
      this.companyData.companyAccountGroupName = data.accountGroup;
      this.companyData.companyName = data.eprName;
      this.companyData.companyGlobalName = data.englishEprName;
      this.companyData.companyRepresentativeName = data.presidentName;
      this.companyData.companyEstablishDTM = utils.toStringByFormat(data.eprEstablishDate, 'YYYY-MM-DD'); // dateformat
      this.companyData.companyEmpValue = data.totalEmployeeNumber;
      this.companyData.corpBizNumber = data.taxNo3;
      this.companyData.companyRepresentativeEmail = data.presidentEmail;
      this.companyData.companyRepresentativeTelNumber = data.presidentTel;
      this.companyData.companyFaxNumber = data.faxNo;
      this.companyData.companyAddress = address;
      this.companyData.companyZipCode = data.zipNo;
      this.companyData.companyHomepageYn = data.homepageYn;
      this.companyData.companyHomepageUrl = data.homepageUrl;
      this.companyData.nationCode = data.nationCode;
      this.companyData.nationName = data.nation;
      this.companyData.companyScaleValue = data.entpScale;
      // 선택
      this.$refs.selectTradePossibility.select(utils.isEmpty(data.blockFlag) ? 'Y' : 'N');
      this.$refs.selectBizDivision.select(data.bizCodeName);
      this.$refs.selectScale.select(data.entpScaleCode);
      this.$refs.selectAffiliatedDivision.select(data.relationCompanyCode);
    },
    goDetailView(companyData) {
      const { companyId, connectionCompanyNumber, companyRegistrationStateCode } = companyData;
      // 상생업체 정보 선택 여부 -- 선택 시 true
      const connectionCompanyFlag = !utils.isEmpty(connectionCompanyNumber);
      // 등록상태 -- 등록완료 시 true
      const companyRegistrationStateFlag = utils.isEqual(companyRegistrationStateCode, '6');
      if (companyRegistrationStateFlag && !connectionCompanyFlag) {
        this.companyDataLoad(companyId);
      } else {
        // utils.goPage('PGE_CMY_00012', {
        //   companyId,
        // });
        this.reset();
        this.$emit('goDetailPage', { companyId, index: 0 });
      }
    },
    onScaleSelect(value) {
      this.companyData.companyScaleValue = value.label;
    },
    getCheckData(corpRegNumber, gerpCompanyNumber) {
      const gerpText = utils.isEmpty(gerpCompanyNumber) ? this.$t('MSG_TXT_NONE') : gerpCompanyNumber;
      return {
        corpRegNumber,
        gerpCompanyNumber,
        crnoFlag: utils.isEmpty(corpRegNumber),
        crnoMsg: `- ${this.$t('MSG_TXT_CORP_DSTG_NO')}: ${corpRegNumber}\n`,
        erpMsg: `- ${this.$t('MSG_TXT_ERP_COMP_CD')}: ${gerpText}`,
      };
    },
    onDuplicateCheckClick() {
      const checkData = this.getCheckData(this.companyData.corpRegNumber, this.companyData.gerpCompanyNumber);
      if (checkData.crnoFlag) {
        // 사업자식별번호 입력하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CORP_DSTG_NO')));
      } else if (this.unchanged) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_CHG_CNTN'));
      } else if (utils.isEqual(this.companyData.nationCode, 'KR')
                  && !utils.isKoreaCorpRegNumber(checkData.corpRegNumber)) {
        const sub = `${this.$t('MSG_TXT_FORM')}: 000-00-00000`;
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_FIT_CRNO_FORM'), sub);
      } else {
        // 중복체크하겠슴?
        utils.messageBox('confirm', this.$t('MSG_ALT_IS_DPCT_CHK'), checkData.crnoMsg + checkData.erpMsg, () => {
          this.duplicateCheckAction(checkData);
        });
      }
    },
    duplicateCheckAction(checkData, connData) {
      http.request(this.$options.name, 'DTS_CMY_00047', {
        query: checkData,
      }).then(res => {
        // const { companyId } = res.data;
        if (!utils.isEmpty(res.data)) {
          // 중복입니다. 해당 업체 조회하겠슴?
          this.duplicateFlag = false;
          const sub = checkData.crnoMsg + checkData.erpMsg;
          utils.messageBox('confirm', this.$t('MSG_ALT_DPCT_COMP_IS_SRCH'), sub, () => {
            this.goDetailView(res.data);
          }, () => {
            // this.companyData.corpRegNumber = this.originalCorpRegNumber;
            // this.companyData.gerpCompanyNumber = this.originalGerpCompanyNumber;
          });
        } else if (utils.isEmpty(connData)) {
          // 타이핑해서 등록 시 -> 사용가능합니다.
          const availableMsg = utils.strFormat(this.$t('MSG_ALT_USE_PSBL'), this.$t('MSG_TXT_COMP_INFO'));
          utils.messageBox('success', availableMsg, null, () => {
            this.duplicateFlag = true;
          });
        } else {
          // 상생업체 선택 시 -> 사용가능합니다.(자동 로딩)
          this.setCompanyDataByConnectionCompanyData(connData);
        }
      }).catch(error => {
        console.log(error);
        this.$refs.selectBqmsVendor.reset();
        this.duplicateFlag = false;
      });
    },
    selectBoxCheckEditableState(rowData) {
      return utils.isEmpty(rowData) ? true : utils.isEmpty(rowData.companyId);
      // return true;
    },
    selectBoxCheckDisabledState() {
      return true;
    },
    useYnCheckEditableState() {
      return true;
    },
    getSaveData() {
      const data = {
        vendorTaskSiteList: this.ds13.data,
        vendorCategoryList: this.vendorCategoryList,
        vendorCreditEvaluationList: this.vendorCreditEvaluationList,
      };
      utils.forEach(this.companyData, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        } else if (utils.isEqual(key, 'companyEstablishDTM')) {
          data[key] = utils.isDate(value) ? utils.dateformatToServer(value) : '';
        } else if (utils.isEqual(key, 'companyHomepageYn')) {
          data[key] = utils.isEmpty(this.companyData.companyHomepageUrl) ? 'N' : 'Y';
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    onModClick() {
      // date picker validation
      if (this.onClickValidate()) return;

      const saveData = this.getSaveData();
      const result = this.validation(saveData);
      if (result.valid) {
        this.saveAction(saveData);
      } else {
        utils.messageBox('warning', result.message, null, () => {
          if (!utils.isEmpty(result.focus)) {
            this.$refs[result.focus].setFocus();
          } else if (!utils.isEmpty(result.grid)) {
            this.$refs.taskSiteGrid.setFocus(result.grid.row, result.grid.column);
          }
        });
      }
    },
    validation(saveData) {
      const result = {
        valid: true,
        focus: '',
        message: '',
        grid: {},
      };
      if (!this.connectionCompanyFlag && !this.unchanged && !this.duplicateFlag) {
        result.valid = false;
        result.message = this.$t('MSG_ALT_SELT_DPCT_CHK');
        result.focus = 'corpRegNumber';
        return result;
      }
      utils.forEach(saveData, (value, key) => {
        if (utils.indexOf(this.validFields, key) !== -1) {
          if (utils.isEmpty(value)) {
            result.valid = false;
            switch (key) {
              case 'companyName':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_COMP_LCL_NM'));
                result.focus = key;
                break;
              case 'corpRegNumber':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CORP_DSTG_NO'));
                result.focus = key;
                break;
              case 'companyGlobalName':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_COMP_GLBL_NM'));
                result.focus = key;
                break;
              case 'bizDivisionCode':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_BIZ_DIV'));
                break;
              case 'companyRepresentativeName':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RPRS_NM'));
                result.focus = key;
                break;
              case 'companyEstablishDTM':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_ESTB_DT'));
                break;
              case 'companyScaleCode':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_COMP_SCALE'));
                break;
              case 'affiliatedCompanyDivisionCode':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_AFCP_YN'));
                break;
              case 'companyRepresentativeEmail':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RPRS_EMAIL'));
                result.focus = key;
                break;
              case 'companyAddress':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_ADDR'));
                result.focus = key;
                break;
              case 'companyRepresentativeTelNumber':
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RPRS_TEL'));
                result.focus = key;
                break;
              default:
                break;
            }
            return false;
          }
        } else if (utils.isEqual(key, 'vendorTaskSiteList')) {
          utils.forEach(value, (data, index) => {
            if (utils.isEmpty(data.companyRelatedTaskDivCode)) {
              result.valid = false;
              const msg = utils.strFormat(this.$t('MSG_ALT_ROW_SELECT'), index + 1, this.$t('MSG_TXT_RLTD_TASK'));
              result.message = msg;
              result.grid.column = 'companyRelatedTaskDivCode';
              result.grid.row = index;
              return false;
            }
            if (utils.isEmpty(data.siteId)) {
              result.valid = false;
              result.message = utils.strFormat(this.$t('MSG_ALT_ROW_SELECT'), index + 1, this.$t('MSG_TXT_SITE'));
              result.grid.column = 'siteId';
              result.grid.row = index;
              return false;
            }
            return null;
          });
        }
        return null;
      });
      return result;
    },
    saveAction(saveData) {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00056', {
          path: {
            'company-id': this.companyData.companyId,
          },
          data: saveData,
        }, true).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            this.ds13.submit();
            this.goDetailView(this.companyData);
          });
        }).catch(error => {
          const { data } = error;
          if (utils.isEqual(data.errorType, 'B')) {
            utils.messageBox('error', data.errorMessage, null, () => {
              this.companyDataLoad(this.companyId);
            });
          } else {
            utils.messageBox('error', data.errorMessage, { title: data.exceptionLogId, content: data.exception });
          }
        });
      });
    },
    addRows() {
      this.ds13.addRows([{
        companyId: '',
        companyRelatedTaskDivCode: '',
        siteId: this.session.siteId,
        companyTaskSiteUseYn: 'Y',
      }]);
    },
    deleteRows() {
      const rowIds = this.ds13.getSelectedRowIds();
      // utils.forEach(rowIds, rowId => {
      //   const deleted = utils.cloneDeep(utils.find(this.ds13.originalData, { 'dataset-row-id': rowId }));
      //   if (!utils.isEmpty(deleted)) {
      //     deleted.deleteFlag = true;
      //     this.deleteList.push(deleted);
      //   }
      // });
      this.ds13.deleteRowsByRowId(rowIds);
    },
    resetRows() {
      this.ds13.reset();
      this.deleteList = [];
    },
    taskSiteDuplicateCheck(rowindex, column) {
      const { siteId, companyRelatedTaskDivCode } = this.ds13.data[rowindex];
      const findindex = utils.findIndex(this.ds13.data, { siteId, companyRelatedTaskDivCode });
      if (findindex !== rowindex && findindex > -1) {
        utils.messageBox('warning', this.$t('MSG_ALT_EXIST_SITE'), null, () => {
          this.ds13.setData(rowindex, column, '');
        });
      }
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
